import { render, staticRenderFns } from "./EditarProdutoPaginaRevista.vue?vue&type=template&id=588a37ba"
import script from "./EditarProdutoPaginaRevista.vue?vue&type=script&lang=ts"
export * from "./EditarProdutoPaginaRevista.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports